import { GROUND_TRUTH_PIXEL_FUZZ_VALUE } from '../constants';
import { IToken } from '../types/my-types';
import { FixMe } from '../types/util';

// Check if there any mismatched token indexes between the marked tokens and the page tokens
export const getMisMatchedIndexTokens = (markedTokens: IToken[], tokenPages: FixMe[]) => {
  return markedTokens.filter((mt: IToken) => {
    const xLeft = mt.bbox[0].x - GROUND_TRUTH_PIXEL_FUZZ_VALUE;
    const xRight = mt.bbox[2].x + GROUND_TRUTH_PIXEL_FUZZ_VALUE;
    const yTop = mt.bbox[0].y - GROUND_TRUTH_PIXEL_FUZZ_VALUE;
    const yBottom = mt.bbox[2].y + GROUND_TRUTH_PIXEL_FUZZ_VALUE;

    // Check for exact token position
    const page = mt.page - 1;
    const foundToken =
      tokenPages[page]?.pageTokens.findIndex((token: IToken) => {
        return (
          (token.index === mt.index ||
            (token.bbox[0].x >= xLeft &&
              token.bbox[2].x <= xRight &&
              token.bbox[0].y <= yBottom &&
              token.bbox[2].y >= yTop)) &&
          token.page === mt.page &&
          token.content === mt.content
        );
      }) !== -1;

    if (!foundToken) {
      return mt;
    }

    return false;
  });
};
